import React from 'react';
import styles from './EArchiveListWrapper.module.scss';

interface Props {
	children: React.ReactNode;
}

const EArchiveListWrapper = ({ children }: Props) => {
	return <div className={styles.wrapper}>{children}</div>;
};

export default EArchiveListWrapper;
